(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunnyhunny-sweats-grid-backup-pre-infinite-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initPleatedAutoplay(root = document) {
    root.querySelectorAll?.('.sh-sweats-product-section--pleated').forEach((section) => {
      if (section.dataset.shPleatedAutoplay === 'true') return;

      const track = section.querySelector('.sh-sweats-grid__items');
      const cards = track ? [...track.querySelectorAll('.sh-sweats-card')] : [];
      if (!track || cards.length < 3) return;

      section.dataset.shPleatedAutoplay = 'true';
      let pauseUntil = 0;
      let isVisible = true;

      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(([entry]) => {
            isVisible = Boolean(entry?.isIntersecting);
          }, { threshold: 0.2 })
        : null;

      observer?.observe(section);

      const pauseForUser = () => {
        pauseUntil = Date.now() + 6500;
      };

      track.addEventListener('pointerdown', pauseForUser, { passive: true });
      track.addEventListener('touchstart', pauseForUser, { passive: true });
      track.addEventListener('wheel', pauseForUser, { passive: true });

      const advance = () => {
        if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden || !isVisible || Date.now() < pauseUntil) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll < 8) return;

        const nearEnd = track.scrollLeft >= maxScroll - 8;
        track.scrollTo({
          left: nearEnd ? 0 : maxScroll,
          behavior: 'smooth',
        });
      };

      const timer = window.setInterval(advance, 3800);

      section.addEventListener('shopify:section:unload', () => {
        window.clearInterval(timer);
        observer?.disconnect();
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPleatedAutoplay(document), { once: true });
  } else {
    initPleatedAutoplay(document);
  }

  document.addEventListener('shopify:section:load', (event) => initPleatedAutoplay(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunnyhunny-sweats-grid-pre-henley-backup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SPEED = 26;
  const MOBILE_MAX = 749;

  function findSections(root) {
    const sections = [];
    if (root?.matches?.('.sh-sweats-product-section--pleated')) sections.push(root);
    root?.querySelectorAll?.('.sh-sweats-product-section--pleated').forEach((section) => sections.push(section));
    return sections;
  }

  function initPleatedMarquee(root = document) {
    findSections(root).forEach((section) => {
      if (section.dataset.shPleatedMarqueeReady === 'true') return;

      const track = section.querySelector('.sh-sweats-grid__items');
      if (!track) return;

      track.querySelectorAll('[data-sh-clone]').forEach((clone) => clone.remove());

      const originals = [...track.children].filter(
        (el) => el.classList?.contains('sh-sweats-card') && !el.hasAttribute('data-sh-clone')
      );
      if (originals.length < 3) return;

      section.dataset.shPleatedMarqueeReady = 'true';

      const clones = originals.map((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-sh-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
        return clone;
      });

      let loopWidth = 0;
      let position = track.scrollLeft || 0;
      let lastTime = 0;
      let pauseUntil = 0;
      let pointerDown = false;
      let rafId = 0;

      const normalizePosition = () => {
        if (loopWidth <= 0) return;
        position = ((position % loopWidth) + loopWidth) % loopWidth;
      };

      const measure = () => {
        if (!clones[0] || !originals[0]) return;
        loopWidth = clones[0].offsetLeft - originals[0].offsetLeft;
        if (loopWidth > 0) {
          position = track.scrollLeft;
          normalizePosition();
          track.scrollLeft = position;
        }
      };

      const pause = (ms = 1000) => {
        pauseUntil = performance.now() + ms;
      };

      const syncAfterInteraction = () => {
        position = track.scrollLeft;
        normalizePosition();
        track.scrollLeft = position;
      };

      const stopDrag = () => {
        if (!pointerDown) return;
        pointerDown = false;
        syncAfterInteraction();
        pause(1000);
      };

      track.addEventListener('pointerdown', () => {
        pointerDown = true;
        position = track.scrollLeft;
      }, { passive: true });

      window.addEventListener('pointerup', stopDrag, { passive: true });
      window.addEventListener('pointercancel', stopDrag, { passive: true });
      track.addEventListener('wheel', () => {
        syncAfterInteraction();
        pause(1000);
      }, { passive: true });

      const tick = (time) => {
        if (!lastTime) lastTime = time;
        const delta = Math.min((time - lastTime) / 1000, 0.08);
        lastTime = time;

        if (
          window.innerWidth <= MOBILE_MAX &&
          !pointerDown &&
          time >= pauseUntil &&
          loopWidth > 0
        ) {
          position += SPEED * delta;
          if (position >= loopWidth) position -= loopWidth;
          track.scrollLeft = position;
        } else if (pointerDown) {
          position = track.scrollLeft;
        }

        rafId = window.requestAnimationFrame(tick);
      };

      window.requestAnimationFrame(() => {
        measure();
        window.requestAnimationFrame(() => {
          measure();
          rafId = window.requestAnimationFrame(tick);
        });
      });
      window.setTimeout(measure, 250);
      window.setTimeout(measure, 1000);

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(measure)
        : null;
      resizeObserver?.observe(track);

      section.addEventListener('shopify:section:unload', () => {
        window.cancelAnimationFrame(rafId);
        resizeObserver?.disconnect();
        clones.forEach((clone) => clone.remove());
        section.removeAttribute('data-sh-pleated-marquee-ready');
      }, { once: true });
    });
  }

  const boot = () => initPleatedMarquee(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.setTimeout(boot, 250);
  window.setTimeout(boot, 1000);

  document.addEventListener('shopify:section:load', (event) => initPleatedMarquee(event.target));

  if ('MutationObserver' in window) {
    const observer = new MutationObserver(() => initPleatedMarquee(document));
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunnyhunny-sweats-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SPEED = 26;
  const MOBILE_MAX = 749;

  function findSections(root) {
    const sections = [];
    if (root?.matches?.('.sh-sweats-product-section--pleated')) sections.push(root);
    root?.querySelectorAll?.('.sh-sweats-product-section--pleated').forEach((section) => sections.push(section));
    return sections;
  }

  function initPleatedMarquee(root = document) {
    findSections(root).forEach((section) => {
      if (section.dataset.shPleatedMarqueeReady === 'true') return;

      const track = section.querySelector('.sh-sweats-grid__items');
      if (!track) return;

      track.querySelectorAll('[data-sh-clone]').forEach((clone) => clone.remove());

      const originals = [...track.children].filter(
        (el) => el.classList?.contains('sh-sweats-card') && !el.hasAttribute('data-sh-clone')
      );
      if (originals.length < 3) return;

      section.dataset.shPleatedMarqueeReady = 'true';

      const clones = originals.map((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('data-sh-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
        return clone;
      });

      let loopWidth = 0;
      let position = track.scrollLeft || 0;
      let lastTime = 0;
      let pauseUntil = 0;
      let pointerDown = false;
      let rafId = 0;

      const normalizePosition = () => {
        if (loopWidth <= 0) return;
        position = ((position % loopWidth) + loopWidth) % loopWidth;
      };

      const measure = () => {
        if (!clones[0] || !originals[0]) return;
        loopWidth = clones[0].offsetLeft - originals[0].offsetLeft;
        if (loopWidth > 0) {
          position = track.scrollLeft;
          normalizePosition();
          track.scrollLeft = position;
        }
      };

      const pause = (ms = 1000) => {
        pauseUntil = performance.now() + ms;
      };

      const syncAfterInteraction = () => {
        position = track.scrollLeft;
        normalizePosition();
        track.scrollLeft = position;
      };

      const stopDrag = () => {
        if (!pointerDown) return;
        pointerDown = false;
        syncAfterInteraction();
        pause(1000);
      };

      track.addEventListener('pointerdown', () => {
        pointerDown = true;
        position = track.scrollLeft;
      }, { passive: true });

      window.addEventListener('pointerup', stopDrag, { passive: true });
      window.addEventListener('pointercancel', stopDrag, { passive: true });
      track.addEventListener('wheel', () => {
        syncAfterInteraction();
        pause(1000);
      }, { passive: true });

      const tick = (time) => {
        if (!lastTime) lastTime = time;
        const delta = Math.min((time - lastTime) / 1000, 0.08);
        lastTime = time;

        if (
          window.innerWidth <= MOBILE_MAX &&
          !pointerDown &&
          time >= pauseUntil &&
          loopWidth > 0
        ) {
          position += SPEED * delta;
          if (position >= loopWidth) position -= loopWidth;
          track.scrollLeft = position;
        } else if (pointerDown) {
          position = track.scrollLeft;
        }

        rafId = window.requestAnimationFrame(tick);
      };

      window.requestAnimationFrame(() => {
        measure();
        window.requestAnimationFrame(() => {
          measure();
          rafId = window.requestAnimationFrame(tick);
        });
      });
      window.setTimeout(measure, 250);
      window.setTimeout(measure, 1000);

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(measure)
        : null;
      resizeObserver?.observe(track);

      section.addEventListener('shopify:section:unload', () => {
        window.cancelAnimationFrame(rafId);
        resizeObserver?.disconnect();
        clones.forEach((clone) => clone.remove());
        section.removeAttribute('data-sh-pleated-marquee-ready');
      }, { once: true });
    });
  }

  const boot = () => initPleatedMarquee(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.setTimeout(boot, 250);
  window.setTimeout(boot, 1000);

  document.addEventListener('shopify:section:load', (event) => initPleatedMarquee(event.target));

  if ('MutationObserver' in window) {
    const observer = new MutationObserver(() => initPleatedMarquee(document));
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
